import React from 'react';
import {Footer, FooterContainer} from './style';	

const FooterComponent = (props) => {
  return (
    <Footer>
    	<FooterContainer>
	    	<span>Todos los derechos reservados | Organize.</span>
	    	<span>Desarrollado por Federico Oliva | Desarrolador Web Freelance</span>    		
    	</FooterContainer>
    </Footer>
  )
}
	
export default FooterComponent;